export class UserRequest{
    id: string
    requestType: number
    title: string
    message: string
    score: any
    label: boolean
    displayName: string
}